export const generateId = () => Math.random().toString(36).substring(2, 15);

// ===================== Workflow Templates =====================
export const workflowTemplates = [
  {
    id: 'wf-tpl-listing',
    name: 'Listing 优化工作流',
    module: 'Listing',
    steps: [
      { stepName: '商品信息收集与身份锁定', source: 'GPTs', migrateStatus: '半迁移', needsReview: true },
      { stepName: 'A10 / IDQ / Rufus / Cosmo / Alexa 五引擎诊断', source: 'Gem', migrateStatus: '半迁移', needsReview: true },
      { stepName: 'QA / 语义 / 场景扩展', source: 'GPTs', migrateStatus: '未迁移', needsReview: true },
      { stepName: 'Listing 正文生成', source: 'API Agent', migrateStatus: '已API化', needsReview: false },
      { stepName: '核查 + 广告词迁移', source: 'API Agent', migrateStatus: '已API化', needsReview: true },
    ]
  },
  {
    id: 'wf-tpl-ads',
    name: '广告诊断工作流',
    module: 'Ads',
    steps: [
      { stepName: '数据校验与分类', source: 'exe', migrateStatus: '未迁移', needsReview: true },
      { stepName: '关键词库整理', source: 'GPTs', migrateStatus: '半迁移', needsReview: false },
      { stepName: '广告结构搭建', source: 'Gem', migrateStatus: '半迁移', needsReview: false },
      { stepName: '广告预算分配', source: 'API Agent', migrateStatus: '已API化', needsReview: false },
      { stepName: '广告 12 维优化', source: 'GPTs', migrateStatus: '迁移中', needsReview: true },
      { stepName: '今日执行清单', source: 'API Agent', migrateStatus: '已API化', needsReview: false },
      { stepName: '7 天监控计划', source: 'API Agent', migrateStatus: '已API化', needsReview: false },
    ]
  },
  {
    id: 'wf-tpl-visual',
    name: '视觉 Prompt 工作流',
    module: 'Visual',
    steps: [
      { stepName: '产品身份锁定', source: 'Opal', migrateStatus: '半迁移', needsReview: true },
      { stepName: '卖点提炼', source: 'GPTs', migrateStatus: '半迁移', needsReview: false },
      { stepName: '图片结构规划', source: 'Gem', migrateStatus: '半迁移', needsReview: false },
      { stepName: '批量 Prompt 生成', source: 'API Agent', migrateStatus: '已API化', needsReview: false },
      { stepName: '视觉质检', source: 'API Agent', migrateStatus: '已API化', needsReview: true },
      { stepName: '导出作图任务', source: 'exe', migrateStatus: '未迁移', needsReview: false },
    ]
  },
  {
    id: 'wf-tpl-qa',
    name: 'QA / Rufus / Cosmo / Alexa 工作流',
    module: 'QA',
    steps: [
      { stepName: '商品页面信息提取', source: 'Gem', migrateStatus: '半迁移', needsReview: true },
      { stepName: 'Rufus 问题生成', source: 'GPTs', migrateStatus: '半迁移', needsReview: false },
      { stepName: 'Cosmo 场景扩展', source: 'Gem', migrateStatus: '半迁移', needsReview: false },
      { stepName: 'Alexa 语音问法生成', source: 'GPTs', migrateStatus: '未迁移', needsReview: false },
      { stepName: 'Return Prevention QA', source: 'API Agent', migrateStatus: '已API化', needsReview: true },
      { stepName: '美国真人买家语气改写', source: 'GPTs', migrateStatus: '迁移中', needsReview: true },
      { stepName: 'QA 去重、分类、导出', source: 'API Agent', migrateStatus: '已API化', needsReview: false },
    ]
  }
];

// ===================== Agents =====================
export const demoAgents = [
  {
    id: 'agent-1', name: 'Listing优化大师', module: 'Listing', agentType: 'single',
    source: 'GPTs', originalLink: 'https://chat.openai.com/g/g-xxxx', migrateStatus: '已API化',
    primaryVersion: 'API Agent', owner: 'Leo', permission: '全部', defaultModel: 'OpenAI', backupModel: 'Gemini',
    promptId: 'prompt-1', knowledgeIds: ['kb-1', 'kb-2'], outputTemplate: '标准Listing输出',
    status: '主用', remark: '核心Listing优化Agent，已完整迁移',
    steps: [], createdAt: '2024-01-15T10:00:00Z', updatedAt: '2024-03-20T14:30:00Z'
  },
  {
    id: 'agent-2', name: 'A10评分助手', module: 'Listing', agentType: 'single',
    source: 'Gem', originalLink: 'https://gemini.google.com/app/xxxx', migrateStatus: '已API化',
    primaryVersion: 'API Agent', owner: 'Leo', permission: '全部', defaultModel: 'Gemini', backupModel: 'OpenAI',
    promptId: 'prompt-2', knowledgeIds: ['kb-1'], outputTemplate: 'A10评分报告',
    status: '主用', remark: 'A10算法评分专用',
    steps: [], createdAt: '2024-02-01T09:00:00Z', updatedAt: '2024-03-18T11:00:00Z'
  },
  {
    id: 'agent-3', name: '广告诊断专家', module: 'Ads', agentType: 'single',
    source: 'GPTs', originalLink: 'https://chat.openai.com/g/g-yyyy', migrateStatus: '迁移中',
    primaryVersion: '保留链接', owner: 'Sarah', permission: 'Manager/Operator', defaultModel: 'OpenAI', backupModel: '中转API',
    promptId: 'prompt-3', knowledgeIds: ['kb-3', 'kb-4'], outputTemplate: '广告动作表',
    status: '测试', remark: '正在从GPTs迁移中，预计本周完成',
    steps: [], createdAt: '2024-01-20T10:00:00Z', updatedAt: '2024-03-22T16:00:00Z'
  },
  {
    id: 'agent-4', name: '视觉Prompt生成器', module: 'Visual', agentType: 'single',
    source: 'Opal', originalLink: 'https://opal.camera/xxxx', migrateStatus: '已API化',
    primaryVersion: 'API Agent', owner: 'Mike', permission: 'Manager/Visual', defaultModel: 'OpenAI', backupModel: 'Gemini',
    promptId: 'prompt-4', knowledgeIds: ['kb-5'], outputTemplate: 'Midjourney/SD Prompt',
    status: '主用', remark: '生成高质量图片Prompt',
    steps: [], createdAt: '2024-02-10T10:00:00Z', updatedAt: '2024-03-15T09:00:00Z'
  },
  {
    id: 'agent-5', name: 'Rufus QA生成器', module: 'QA', agentType: 'single',
    source: 'exe', originalLink: 'local://qa-generator.exe', migrateStatus: '未迁移',
    primaryVersion: 'exe', owner: 'Leo', permission: '全部', defaultModel: 'Gemini', backupModel: 'OpenAI',
    promptId: null, knowledgeIds: [], outputTemplate: 'QA问答对',
    status: '主用', remark: '本地exe工具，计划Q2迁移',
    steps: [], createdAt: '2023-12-01T10:00:00Z', updatedAt: '2024-03-01T10:00:00Z'
  },
  {
    id: 'agent-6', name: 'IDQ质量检测', module: 'Listing', agentType: 'single',
    source: 'API Agent', originalLink: '', migrateStatus: '已API化',
    primaryVersion: 'API Agent', owner: 'Sarah', permission: '全部', defaultModel: '中转API', backupModel: 'OpenAI',
    promptId: 'prompt-5', knowledgeIds: ['kb-2'], outputTemplate: 'IDQ检测报告',
    status: '主用', remark: '原生API Agent',
    steps: [], createdAt: '2024-03-01T10:00:00Z', updatedAt: '2024-03-20T10:00:00Z'
  },
  {
    id: 'agent-7', name: 'Cosmo优化助手', module: 'QA', agentType: 'single',
    source: 'Gem', originalLink: 'https://gemini.google.com/app/yyyy', migrateStatus: '保留链接',
    primaryVersion: '保留链接', owner: 'Mike', permission: 'Manager/Operator', defaultModel: 'Gemini', backupModel: 'OpenAI',
    promptId: 'prompt-6', knowledgeIds: ['kb-6'], outputTemplate: 'Cosmo优化建议',
    status: '测试', remark: '暂时保留Gemini链接',
    steps: [], createdAt: '2024-02-20T10:00:00Z', updatedAt: '2024-03-18T10:00:00Z'
  },
  {
    id: 'agent-8', name: 'Alexa语音优化', module: 'QA', agentType: 'single',
    source: 'GPTs', originalLink: 'https://chat.openai.com/g/g-zzzz', migrateStatus: '迁移中',
    primaryVersion: '保留链接', owner: 'Leo', permission: '全部', defaultModel: 'OpenAI', backupModel: 'Gemini',
    promptId: 'prompt-7', knowledgeIds: ['kb-7'], outputTemplate: 'Alexa语音优化方案',
    status: '测试', remark: '语音搜索优化专用',
    steps: [], createdAt: '2024-01-25T10:00:00Z', updatedAt: '2024-03-21T10:00:00Z'
  },
  // Workflow Agents
  {
    id: 'wf-agent-1', name: 'Listing 优化工作流', module: 'Listing', agentType: 'workflow',
    source: '混合', originalLink: '', migrateStatus: '半迁移', primaryVersion: '工作流', owner: 'Leo',
    permission: '全部', defaultModel: 'OpenAI', backupModel: 'Gemini', promptId: null, knowledgeIds: [],
    outputTemplate: '完整Listing优化包', status: '主用', remark: '5步Listing优化工作流',
    steps: [
      { stepId: 's1', stepNumber: 1, stepName: '商品信息收集与身份锁定', source: 'GPTs', originalLink: '', migrateStatus: '半迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '产品名称、核心卖点、目标受众、竞品关键词', outputStandard: '结构化的商品身份档案', needsReview: true, status: '主用', remark: '' },
      { stepId: 's2', stepNumber: 2, stepName: '五引擎诊断', source: 'Gem', originalLink: '', migrateStatus: '半迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-1'], defaultModel: 'Gemini', backupModel: 'OpenAI', inputRequirements: '商品身份档案', outputStandard: 'A10/IDQ/Rufus/Cosmo/Alexa五维度评分与问题清单', needsReview: true, status: '主用', remark: '' },
      { stepId: 's3', stepNumber: 3, stepName: 'QA / 语义 / 场景扩展', source: 'GPTs', originalLink: '', migrateStatus: '未迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-6','kb-7'], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '诊断结果', outputStandard: '扩展的QA对和语义覆盖建议', needsReview: true, status: '测试', remark: '' },
      { stepId: 's4', stepNumber: 4, stepName: 'Listing 正文生成', source: 'API Agent', originalLink: '', migrateStatus: '已API化', systemPromptId: 'prompt-1', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-1','kb-2'], defaultModel: 'OpenAI', backupModel: '中转API', inputRequirements: '所有前置输出', outputStandard: '优化后的标题、五点、后台关键词', needsReview: false, status: '主用', remark: '' },
      { stepId: 's5', stepNumber: 5, stepName: '核查 + 广告词迁移', source: 'API Agent', originalLink: '', migrateStatus: '已API化', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: 'prompt-5', knowledgeIds: ['kb-2'], defaultModel: '中转API', backupModel: 'OpenAI', inputRequirements: 'Listing正文', outputStandard: '核查通过报告 + 广告关键词清单', needsReview: true, status: '主用', remark: '' },
    ],
    createdAt: '2024-03-01T10:00:00Z', updatedAt: '2024-03-20T10:00:00Z'
  },
  {
    id: 'wf-agent-2', name: '广告诊断工作流', module: 'Ads', agentType: 'workflow',
    source: '混合', originalLink: '', migrateStatus: '半迁移', primaryVersion: '工作流', owner: 'Sarah',
    permission: 'Manager/Operator', defaultModel: 'OpenAI', backupModel: '中转API', promptId: null, knowledgeIds: [],
    outputTemplate: '广告动作表 + 监控计划', status: '主用', remark: '7步广告诊断与优化工作流',
    steps: [
      { stepId: 'a1', stepNumber: 1, stepName: '数据校验与分类', source: 'exe', originalLink: '', migrateStatus: '未迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-3'], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '广告报表文件', outputStandard: '校验报告 + 分类后的数据结构', needsReview: true, status: '主用', remark: '' },
      { stepId: 'a2', stepNumber: 2, stepName: '关键词库整理', source: 'GPTs', originalLink: '', migrateStatus: '半迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '分类后的搜索词数据', outputStandard: '结构化关键词库（高转化/低转化/否定）', needsReview: false, status: '主用', remark: '' },
      { stepId: 'a3', stepNumber: 3, stepName: '广告结构搭建', source: 'Gem', originalLink: '', migrateStatus: '半迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-3'], defaultModel: 'Gemini', backupModel: 'OpenAI', inputRequirements: '关键词库', outputStandard: 'Campaign/Ad Group/Keyword 结构建议', needsReview: false, status: '测试', remark: '' },
      { stepId: 'a4', stepNumber: 4, stepName: '广告预算分配', source: 'API Agent', originalLink: '', migrateStatus: '已API化', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: 'OpenAI', backupModel: '中转API', inputRequirements: '结构建议 + 历史数据', outputStandard: '预算分配表', needsReview: false, status: '主用', remark: '' },
      { stepId: 'a5', stepNumber: 5, stepName: '广告 12 维优化', source: 'GPTs', originalLink: '', migrateStatus: '迁移中', systemPromptId: 'prompt-3', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-3','kb-4'], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '全量数据', outputStandard: '12维度优化动作表', needsReview: true, status: '测试', remark: '' },
      { stepId: 'a6', stepNumber: 6, stepName: '今日执行清单', source: 'API Agent', originalLink: '', migrateStatus: '已API化', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: '中转API', backupModel: 'OpenAI', inputRequirements: '动作表', outputStandard: '可执行的今日任务清单', needsReview: false, status: '主用', remark: '' },
      { stepId: 'a7', stepNumber: 7, stepName: '7 天监控计划', source: 'API Agent', originalLink: '', migrateStatus: '已API化', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '执行清单', outputStandard: '7天监控检查表', needsReview: false, status: '主用', remark: '' },
    ],
    createdAt: '2024-03-01T10:00:00Z', updatedAt: '2024-03-20T10:00:00Z'
  },
  {
    id: 'wf-agent-3', name: '视觉 Prompt 工作流', module: 'Visual', agentType: 'workflow',
    source: '混合', originalLink: '', migrateStatus: '半迁移', primaryVersion: '工作流', owner: 'Mike',
    permission: 'Manager/Visual', defaultModel: 'OpenAI', backupModel: 'Gemini', promptId: null, knowledgeIds: [],
    outputTemplate: '批量作图任务包', status: '主用', remark: '6步视觉工作流',
    steps: [
      { stepId: 'v1', stepNumber: 1, stepName: '产品身份锁定', source: 'Opal', originalLink: '', migrateStatus: '半迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '产品图、参数表', outputStandard: '产品身份卡', needsReview: true, status: '主用', remark: '' },
      { stepId: 'v2', stepNumber: 2, stepName: '卖点提炼', source: 'GPTs', originalLink: '', migrateStatus: '半迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-5'], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '产品身份卡', outputStandard: '卖点列表', needsReview: false, status: '主用', remark: '' },
      { stepId: 'v3', stepNumber: 3, stepName: '图片结构规划', source: 'Gem', originalLink: '', migrateStatus: '半迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: 'Gemini', backupModel: 'OpenAI', inputRequirements: '卖点列表', outputStandard: '图片结构规划表', needsReview: false, status: '测试', remark: '' },
      { stepId: 'v4', stepNumber: 4, stepName: '批量 Prompt 生成', source: 'API Agent', originalLink: '', migrateStatus: '已API化', systemPromptId: 'prompt-4', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-5'], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '图片结构规划', outputStandard: '每张图的Prompt', needsReview: false, status: '主用', remark: '' },
      { stepId: 'v5', stepNumber: 5, stepName: '视觉质检', source: 'API Agent', originalLink: '', migrateStatus: '已API化', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: '中转API', backupModel: 'OpenAI', inputRequirements: '生成的Prompt', outputStandard: '质检报告', needsReview: true, status: '主用', remark: '' },
      { stepId: 'v6', stepNumber: 6, stepName: '导出作图任务', source: 'exe', originalLink: '', migrateStatus: '未迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '质检通过的Prompt', outputStandard: '作图任务队列', needsReview: false, status: '主用', remark: '' },
    ],
    createdAt: '2024-03-01T10:00:00Z', updatedAt: '2024-03-20T10:00:00Z'
  },
  {
    id: 'wf-agent-4', name: 'QA 生成工作流', module: 'QA', agentType: 'workflow',
    source: '混合', originalLink: '', migrateStatus: '半迁移', primaryVersion: '工作流', owner: 'Leo',
    permission: '全部', defaultModel: 'Gemini', backupModel: 'OpenAI', promptId: null, knowledgeIds: [],
    outputTemplate: 'QA问答包', status: '主用', remark: '7步QA工作流',
    steps: [
      { stepId: 'q1', stepNumber: 1, stepName: '商品页面信息提取', source: 'Gem', originalLink: '', migrateStatus: '半迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: 'Gemini', backupModel: 'OpenAI', inputRequirements: 'Amazon链接或标题五点', outputStandard: '结构化商品信息', needsReview: true, status: '主用', remark: '' },
      { stepId: 'q2', stepNumber: 2, stepName: 'Rufus 问题生成', source: 'GPTs', originalLink: '', migrateStatus: '半迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-6'], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '商品信息', outputStandard: 'Rufus QA对', needsReview: false, status: '主用', remark: '' },
      { stepId: 'q3', stepNumber: 3, stepName: 'Cosmo 场景扩展', source: 'Gem', originalLink: '', migrateStatus: '半迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-6'], defaultModel: 'Gemini', backupModel: 'OpenAI', inputRequirements: 'Rufus QA', outputStandard: 'Cosmo场景扩展', needsReview: false, status: '测试', remark: '' },
      { stepId: 'q4', stepNumber: 4, stepName: 'Alexa 语音问法生成', source: 'GPTs', originalLink: '', migrateStatus: '未迁移', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: ['kb-7'], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: 'Cosmo场景', outputStandard: 'Alexa语音问法', needsReview: false, status: '测试', remark: '' },
      { stepId: 'q5', stepNumber: 5, stepName: 'Return Prevention QA', source: 'API Agent', originalLink: '', migrateStatus: '已API化', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: '中转API', backupModel: 'OpenAI', inputRequirements: '全部QA', outputStandard: '退货预防QA', needsReview: true, status: '主用', remark: '' },
      { stepId: 'q6', stepNumber: 6, stepName: '美国真人买家语气改写', source: 'GPTs', originalLink: '', migrateStatus: '迁移中', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '全部QA', outputStandard: '真人语气QA', needsReview: true, status: '测试', remark: '' },
      { stepId: 'q7', stepNumber: 7, stepName: 'QA 去重、分类、导出', source: 'API Agent', originalLink: '', migrateStatus: '已API化', systemPromptId: '', inputTemplateId: '', outputTemplateId: '', checkerPromptId: '', knowledgeIds: [], defaultModel: 'OpenAI', backupModel: 'Gemini', inputRequirements: '全部QA', outputStandard: '最终QA包', needsReview: false, status: '主用', remark: '' },
    ],
    createdAt: '2024-03-01T10:00:00Z', updatedAt: '2024-03-20T10:00:00Z'
  }
];

// ===================== Prompts =====================
export const demoPrompts = [
  {
    id: 'prompt-1', name: 'Listing优化System Prompt', module: 'Listing', workflowId: '', stepId: '',
    version: 'v3.2', type: 'System Prompt',
    content: `你是一位亚马逊Listing优化专家。请根据以下产品信息，生成优化的标题、五点描述和后台关键词。\n\n输入格式：\n- 产品名称：{productName}\n- 核心卖点：{sellingPoints}\n- 目标受众：{targetAudience}\n- 竞品关键词：{competitorKeywords}\n\n输出要求：\n1. 标题不超过200字符，包含核心关键词\n2. 五点描述每点不超过500字符\n3. 后台关键词提供250字节的关键词列表\n4. 符合Amazon A10算法要求`,
    agentIds: ['agent-1'], bindKnowledgeIds: ['kb-1','kb-2'],
    status: '主用', updater: 'Leo', updatedAt: '2024-03-20T14:30:00Z', changeNote: '优化了A10算法匹配逻辑，增加了Rufus友好性'
  },
  {
    id: 'prompt-2', name: 'A10评分System Prompt', module: 'Listing', workflowId: '', stepId: '',
    version: 'v2.1', type: 'System Prompt',
    content: `你是一位A10算法评分专家。请分析以下Listing的各项指标并给出评分。\n\n评分维度：\n1. 标题优化度（0-100）\n2. 图片质量（0-100）\n3. 五点描述完整度（0-100）\n4. 关键词覆盖度（0-100）\n5. 价格竞争力（0-100）\n6. Review质量（0-100）\n\n输出格式：JSON格式，包含各项得分和改进建议。`,
    agentIds: ['agent-2'], bindKnowledgeIds: ['kb-1'],
    status: '主用', updater: 'Leo', updatedAt: '2024-03-18T11:00:00Z', changeNote: '新增Review质量评估维度'
  },
  {
    id: 'prompt-3', name: '广告诊断System Prompt', module: 'Ads', workflowId: 'wf-agent-2', stepId: 'a5',
    version: 'v1.5', type: 'Workflow Prompt',
    content: `你是一位亚马逊广告优化专家。请分析以下广告数据并输出优化动作表。\n\n输入数据：\n- Campaign名称及数据\n- Ad Group表现\n- 关键词报告\n- 搜索词报告\n\n输出要求：\n1. 识别低效Campaign（ACOS>TACOS+20%）\n2. 识别高潜力关键词\n3. 建议否定关键词\n4. 建议预算调整\n5. 建议竞价调整\n\n输出格式：表格形式，包含Action/Item/Current/Target/Reason。`,
    agentIds: ['agent-3'], bindKnowledgeIds: ['kb-3','kb-4'],
    status: '主用', updater: 'Sarah', updatedAt: '2024-03-22T16:00:00Z', changeNote: '优化了预算调整算法'
  },
  {
    id: 'prompt-4', name: '视觉Prompt生成器', module: 'Visual', workflowId: 'wf-agent-3', stepId: 'v4',
    version: 'v2.0', type: 'Batch Prompt',
    content: `你是一位AI图片Prompt工程专家。请根据产品信息生成高质量的Midjourney/Stable Diffusion Prompt。\n\n输入：\n- 产品类型\n- 图片用途（主图/A+/场景图）\n- 风格偏好\n\n输出：\n1. Midjourney Prompt（英文）\n2. Stable Diffusion Prompt（英文）\n3. 负面Prompt\n4. 推荐参数`,
    agentIds: ['agent-4'], bindKnowledgeIds: ['kb-5'],
    status: '主用', updater: 'Mike', updatedAt: '2024-03-15T09:00:00Z', changeNote: '新增A+图片专用Prompt模板'
  },
  {
    id: 'prompt-5', name: 'IDQ检测Checker Prompt', module: 'Listing', workflowId: 'wf-agent-1', stepId: 's5',
    version: 'v1.0', type: 'Checker Prompt',
    content: `请检查以下Listing是否符合Amazon IDQ（Item Data Quality）标准。\n\n检查项：\n1. 标题格式正确性\n2. 图片规格合规性\n3. 分类节点准确性\n4. 变体关系正确性\n5. 必填属性完整性\n\n输出：通过/不通过，附详细问题列表。`,
    agentIds: ['agent-6'], bindKnowledgeIds: ['kb-2'],
    status: '主用', updater: 'Sarah', updatedAt: '2024-03-20T10:00:00Z', changeNote: '初始版本'
  },
  {
    id: 'prompt-6', name: 'Cosmo优化Prompt', module: 'QA', workflowId: '', stepId: '',
    version: 'v1.2', type: 'System Prompt',
    content: `你是一位Amazon Cosmo算法优化专家。请根据产品信息生成Cosmo友好的内容。\n\nCosmo优化要点：\n1. 多意图识别友好\n2. 知识图谱关联\n3. 常识推理优化\n4. 用户行为预测\n\n输出：优化后的产品描述和Q&A建议。`,
    agentIds: ['agent-7'], bindKnowledgeIds: ['kb-6'],
    status: '测试', updater: 'Mike', updatedAt: '2024-03-18T10:00:00Z', changeNote: '新增用户行为预测模块'
  },
  {
    id: 'prompt-7', name: 'Alexa语音优化Prompt', module: 'QA', workflowId: '', stepId: '',
    version: 'v1.0', type: 'System Prompt',
    content: `你是一位Alexa语音搜索优化专家。请生成适合语音搜索的内容。\n\n语音搜索特点：\n1. 长尾问句形式\n2. 对话式内容\n3. 结构化数据友好\n4. FAQ格式优化\n\n输出：语音搜索优化方案。`,
    agentIds: ['agent-8'], bindKnowledgeIds: ['kb-7'],
    status: '测试', updater: 'Leo', updatedAt: '2024-03-21T10:00:00Z', changeNote: '初始版本'
  },
  {
    id: 'prompt-8', name: '广告报表Input Template', module: 'Ads', workflowId: 'wf-agent-2', stepId: 'a1',
    version: 'v1.0', type: 'Input Template',
    content: `请上传以下格式的广告报表：\n\n- Sponsored Products Search Term Report\n- Campaign Report\n- Targeting Report\n\n系统将自动识别报表类型并校验字段完整性。`,
    agentIds: [], bindKnowledgeIds: ['kb-3'],
    status: '主用', updater: 'Sarah', updatedAt: '2024-03-22T10:00:00Z', changeNote: '新增报表输入模板'
  },
  {
    id: 'prompt-9', name: '视觉质检Checker Prompt', module: 'Visual', workflowId: 'wf-agent-3', stepId: 'v5',
    version: 'v1.0', type: 'Checker Prompt',
    content: `你是一位亚马逊视觉质检专家。请检查以下图片Prompt是否符合规范。\n\n3C充电器专项规则：\n- 接口不能跑偏\n- USB-C / 圆口 / 插头必须正确\n- 电源主体、插头、线材连接符合物理规律\n- 不能出现多根错误线材\n- 不能出现不支持的品牌Logo\n- 不能出现虚假认证\n- 不能出现错误规格\n- 不能出现多余配件\n- 标签文字不能乱写\n- 插头、线材、适配器比例合理`,
    agentIds: [], bindKnowledgeIds: ['kb-5'],
    status: '主用', updater: 'Mike', updatedAt: '2024-03-15T10:00:00Z', changeNote: '新增3C充电器质检规则'
  }
];

// ===================== Knowledge Bases =====================
export const demoKnowledgeBases = [
  {
    id: 'kb-1', name: 'A10算法规则库', category: 'A10 Rules',
    content: '# A10算法规则\n\n## 核心排名因素\n1. 销售速度（Sales Velocity）\n2. 转化率（Conversion Rate）\n3. 相关性（Relevance）\n4. 客户满意度（Customer Satisfaction）\n5. 价格竞争力\n\n## 优化策略\n- 提升CTR和CVR\n- 优化关键词布局\n- 获取高质量Review\n- 保持库存充足',
    fileType: 'Markdown', version: 'v2.0', status: '主用',
    agentIds: ['agent-1', 'agent-2'], owner: 'Leo', updatedAt: '2024-03-15T10:00:00Z', remark: 'A10算法核心规则汇总'
  },
  {
    id: 'kb-2', name: 'IDQ质量规范', category: 'IDQ Rules',
    content: '# IDQ质量规范\n\n## 图片要求\n- 主图：纯白背景，RGB 255,255,255\n- 尺寸：至少1000x1000px\n- 格式：JPEG/JPG/PNG/TIFF\n\n## 标题规范\n- 最多200字符\n- 首字母大写\n- 禁止特殊字符',
    fileType: 'Markdown', version: 'v1.5', status: '主用',
    agentIds: ['agent-1', 'agent-6'], owner: 'Sarah', updatedAt: '2024-03-10T10:00:00Z', remark: 'Amazon官方IDQ规范'
  },
  {
    id: 'kb-3', name: '广告投放SOP', category: 'Ads Rules',
    content: '# 广告投放SOP\n\n## 新品期\n1. 自动广告跑词\n2. 每日预算$20-50\n3. 收集搜索词报告\n\n## 成长期\n1. 转手动精准\n2. 优化ACOS\n3. 拓展关键词',
    fileType: 'Markdown', version: 'v3.0', status: '主用',
    agentIds: ['agent-3'], owner: 'Sarah', updatedAt: '2024-03-12T10:00:00Z', remark: '广告投放标准操作流程'
  },
  {
    id: 'kb-4', name: '广告案例库', category: 'Cases',
    content: '# 广告优化案例\n\n## 案例1：ACOS从45%降到18%\n- 产品：蓝牙耳机\n- 动作：否定低效词+提升高转化词竞价\n- 周期：2周\n\n## 案例2：TACOS优化\n- 产品：手机壳\n- 动作：SB广告+SD再营销',
    fileType: 'Markdown', version: 'v1.0', status: '主用',
    agentIds: ['agent-3'], owner: 'Leo', updatedAt: '2024-03-05T10:00:00Z', remark: '历史广告优化成功案例'
  },
  {
    id: 'kb-5', name: '视觉设计规范', category: 'Visual Rules',
    content: '# 视觉设计规范\n\n## 主图标准\n- 2500x2500px\n- 纯白背景\n- 产品占画面85%\n\n## A+图片\n- 1464x600px\n- 品牌故事风格\n- 信息图表',
    fileType: 'Markdown', version: 'v1.2', status: '主用',
    agentIds: ['agent-4'], owner: 'Mike', updatedAt: '2024-03-08T10:00:00Z', remark: '亚马逊视觉设计标准'
  },
  {
    id: 'kb-6', name: 'Cosmo算法解读', category: 'Cosmo Rules',
    content: '# Cosmo算法解读\n\n## 核心变化\n1. 从单意图到多意图\n2. 引入知识图谱\n3. 常识推理\n4. 用户画像关联\n\n## 优化方向\n- 多场景描述\n- 关联属性丰富\n- 用户行为预测',
    fileType: 'Markdown', version: 'v1.0', status: '主用',
    agentIds: ['agent-7'], owner: 'Mike', updatedAt: '2024-03-18T10:00:00Z', remark: 'Cosmo算法最新解读'
  },
  {
    id: 'kb-7', name: 'Alexa语音搜索指南', category: 'Alexa Rules',
    content: '# Alexa语音搜索\n\n## 语音搜索特点\n1. 更长的查询\n2. 问句形式\n3. 本地化\n4. 个性化\n\n## 优化策略\n- FAQ格式\n- 自然语言\n- 结构化数据',
    fileType: 'Markdown', version: 'v1.0', status: '主用',
    agentIds: ['agent-8'], owner: 'Leo', updatedAt: '2024-03-20T10:00:00Z', remark: 'Alexa语音搜索优化指南'
  }
];

// ===================== KB Files (Uploaded Files) =====================
export const demoKbFiles = [
  {
    id: 'file-1', fileName: 'A10算法白皮书.pdf', fileType: 'PDF', fileSize: 2450000,
    uploadedBy: 'Leo', uploadedAt: '2024-03-10T10:00:00Z', category: 'A10 Rules',
    aiSuggestedCategory: 'A10 Rules', agentIds: ['agent-1'], stepIds: ['s2'],
    summary: 'Amazon A10算法官方白皮书，包含排名因素详解', keyRules: '销售速度、转化率、相关性、客户满意度、价格竞争力',
    riskPoints: '过度优化可能导致惩罚', tags: ['A10','算法','排名'],
    version: 'v1.0', status: '主用', isParsed: true, isBoundToAgent: true
  },
  {
    id: 'file-2', fileName: 'SearchTermReport_March.csv', fileType: 'CSV', fileSize: 120000,
    uploadedBy: 'Sarah', uploadedAt: '2024-03-15T14:00:00Z', category: 'Ads Rules',
    aiSuggestedCategory: 'Search Term Report', agentIds: ['agent-3'], stepIds: ['a1'],
    summary: '3月搜索词报告，包含Campaign A/B的搜索词数据', keyRules: '高花费无转化词需要否定',
    riskPoints: '报告可能包含延迟数据', tags: ['广告','搜索词','报表'],
    version: 'v1.0', status: '主用', isParsed: true, isBoundToAgent: true
  },
  {
    id: 'file-3', fileName: '竞品QA截图.zip', fileType: 'ZIP', fileSize: 8500000,
    uploadedBy: 'Mike', uploadedAt: '2024-03-12T09:00:00Z', category: 'Raw Uploads',
    aiSuggestedCategory: 'QA Rules', agentIds: [], stepIds: [],
    summary: '5个竞品的前台QA截图压缩包', keyRules: '', riskPoints: '',
    tags: ['竞品','QA','截图'], version: 'v1.0', status: '草稿', isParsed: false, isBoundToAgent: false
  }
];

// ===================== Model Configs =====================
export const demoModelConfigs = [
  {
    id: 'model-1', provider: 'OpenAI', baseUrl: 'https://api.openai.com/v1', modelName: 'gpt-4o',
    apiKeyConfigured: true, dailyBudget: 50, monthlyBudget: 1000, maxTokens: 4096, temperature: 0.7,
    enabled: true, backupModel: 'gpt-4o-mini', callLogs: 1250, failureCount: 12, lastCalledAt: '2024-03-22T10:00:00Z'
  },
  {
    id: 'model-2', provider: 'Gemini', baseUrl: 'https://generativelanguage.googleapis.com/v1beta', modelName: 'gemini-1.5-pro',
    apiKeyConfigured: true, dailyBudget: 30, monthlyBudget: 600, maxTokens: 8192, temperature: 0.5,
    enabled: true, backupModel: 'gemini-1.5-flash', callLogs: 890, failureCount: 5, lastCalledAt: '2024-03-22T08:00:00Z'
  },
  {
    id: 'model-3', provider: '中转 API', baseUrl: 'https://api.example.com/v1', modelName: 'claude-3-5-sonnet',
    apiKeyConfigured: false, dailyBudget: 20, monthlyBudget: 400, maxTokens: 4096, temperature: 0.7,
    enabled: false, backupModel: 'gpt-4o', callLogs: 0, failureCount: 0, lastCalledAt: ''
  },
  {
    id: 'model-4', provider: 'Custom OpenAI Compatible API', baseUrl: 'https://custom.example.com/v1', modelName: 'custom-model',
    apiKeyConfigured: false, dailyBudget: 10, monthlyBudget: 200, maxTokens: 2048, temperature: 0.8,
    enabled: false, backupModel: '', callLogs: 0, failureCount: 0, lastCalledAt: ''
  }
];

// ===================== Tasks =====================
export const demoTasks = [
  {
    id: 'task-1', name: '蓝牙耳机Listing优化', type: 'Listing', workflowId: 'wf-agent-1', stepId: 's4',
    agentId: 'agent-1', promptVersion: 'v3.2', knowledgeVersion: 'v2.0',
    model: 'OpenAI', inputFiles: [], inputText: '产品：TWS蓝牙耳机\n卖点：降噪40dB、续航30h、蓝牙5.3\n受众：通勤族、学生\n竞品关键词：wireless earbuds, noise cancelling',
    aiOutput: '【AI生成的Listing内容...】', humanEdit: null, adopted: null, reviewStatus: '待审核',
    owner: 'Sarah', reviewer: '', createdAt: '2024-03-22T09:00:00Z', updatedAt: '2024-03-22T09:00:00Z'
  },
  {
    id: 'task-2', name: '广告周报诊断', type: 'Ads', workflowId: '', stepId: '',
    agentId: 'agent-3', promptVersion: 'v1.5', knowledgeVersion: 'v3.0',
    model: 'OpenAI', inputFiles: ['file-2'], inputText: 'Campaign数据：\n- Campaign A: ACOS 35%, 花费$500\n- Campaign B: ACOS 18%, 花费$300',
    aiOutput: '【AI诊断结果...】', humanEdit: '【人工修改后...】', adopted: true, reviewStatus: '已采纳',
    owner: 'Leo', reviewer: 'Sarah', createdAt: '2024-03-21T10:00:00Z', updatedAt: '2024-03-21T14:00:00Z'
  },
  {
    id: 'task-3', name: '主图Prompt生成', type: 'Visual', workflowId: 'wf-agent-3', stepId: 'v4',
    agentId: 'agent-4', promptVersion: 'v2.0', knowledgeVersion: 'v1.2',
    model: 'Gemini', inputFiles: [], inputText: '产品：智能手表\n用途：主图\n风格：科技感、简约',
    aiOutput: '【AI生成的Prompt...】', humanEdit: null, adopted: null, reviewStatus: '待审核',
    owner: 'Mike', reviewer: '', createdAt: '2024-03-22T14:00:00Z', updatedAt: '2024-03-22T14:00:00Z'
  }
];

// ===================== Reviews =====================
export const demoReviews = [
  {
    id: 'review-1', taskName: '蓝牙耳机Listing优化', taskType: 'Listing', workflow: 'wf-agent-1', step: 's4',
    agentId: 'agent-1', promptVersion: 'v3.2', knowledgeVersion: 'v2.0',
    model: 'OpenAI', inputSummary: '产品：TWS蓝牙耳机...',
    aiOutput: '【AI输出】', humanEdit: '【人工修改】', adopted: '采纳', failureReason: '',
    metrics: { ctr: '2.5%', cvr: '12%', acos: '22%', tacos: '18%', unitSession: '15%', orders: 45, sales: 3200 },
    conclusion: '优化后CTR提升0.8%，CVR提升3%', feedbackPrompt: true, feedbackKnowledge: false, generateNewRule: true,
    owner: 'Leo', date: '2024-03-15'
  },
  {
    id: 'review-2', taskName: '广告周报诊断', taskType: 'Ads', workflow: '', step: '',
    agentId: 'agent-3', promptVersion: 'v1.5', knowledgeVersion: 'v3.0',
    model: 'OpenAI', inputSummary: 'Campaign数据...',
    aiOutput: '【AI输出】', humanEdit: '【人工修改】', adopted: '部分采纳', failureReason: '部分预算建议过于激进',
    metrics: { ctr: '1.8%', cvr: '8%', acos: '18%', tacos: '15%', unitSession: '10%', orders: 28, sales: 1800 },
    conclusion: 'ACOS从35%降到18%，效果超预期', feedbackPrompt: true, feedbackKnowledge: true, generateNewRule: false,
    owner: 'Leo', date: '2024-03-10'
  }
];

// ===================== Visual Batch Tasks =====================
export const demoVisualBatchTasks = [
  {
    id: 'vt-1', taskName: '智能手表视觉包', imageCount: 15, model: 'Midjourney v6',
    prompts: ['Main image prompt...', 'A+ module 1 prompt...'],
    status: '已完成', outputLinks: ['https://example.com/img1.png'], humanScore: 8, adopted: true
  }
];

// ===================== QA Batch Configs =====================
export const demoQaBatchConfigs = [
  {
    id: 'qa-batch-1', asin: 'B08XXXXXX', site: 'US', qaType: 'Rufus',
    count: 20, tone: true, alexa: false, returnPrevention: true, exportFormat: 'CSV'
  }
];

// ===================== Users & Roles =====================
export const rolePermissions = {
  Admin: ['全部权限'],
  Manager: ['审核', '查看全部结果', '管理Prompt', '管理知识库'],
  Operator: ['使用Listing工作台', '使用Ads工作台', '使用QA工作台', '提交任务'],
  Visual: ['使用Visual工作台', '提交任务', '查看知识库'],
  Assistant: ['提交任务', '查看知识库', '查看Prompt'],
  Viewer: ['只读']
};

export const demoUsers = [
  { id: 'user-1', name: 'Leo', role: 'Admin', avatar: 'L' },
  { id: 'user-2', name: 'Sarah', role: 'Manager', avatar: 'S' },
  { id: 'user-3', name: 'Mike', role: 'Visual', avatar: 'M' },
  { id: 'user-4', name: 'Alice', role: 'Operator', avatar: 'A' },
  { id: 'user-5', name: 'Bob', role: 'Assistant', avatar: 'B' },
  { id: 'user-6', name: 'Guest', role: 'Viewer', avatar: 'G' }
];
